import { getActionBasedOnType } from "@/utils/flows";
import { useMemo } from "react";
import { ActionHeader } from "../ActionHeader";

export const StartWithAnIndividual = () => {
  const action = useMemo(() => getActionBasedOnType("startWithIndividual"), []);

  const isLoading = false;

  return (
    <div>
      {isLoading ? (
        <>Loading</>
      ) : (
        action && (
          <div>
            <ActionHeader action={action} category="Trigger" />

            <div className="mt-4">
              <div className="mb-2">
                <h3 className="dark:text-zinc-300 text-sm">Configuration</h3>
                <p className="text-xs dark:text-zinc-600 mt-0.5">
                  This is a manual trigger, no configuration needed.
                </p>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};
